function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Groupe_2587",
  "data-name": "Groupe 2587"
}, /*#__PURE__*/React.createElement("g", {
  id: "Groupe_1035",
  "data-name": "Groupe 1035"
}, /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_7942",
  "data-name": "Trac\\xE9 7942",
  d: "M500,598.09,0,393.66,500,189.29l500,204.37Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_7943",
  "data-name": "Trac\\xE9 7943",
  d: "M63.42,595.49V461.29L26.23,446.07V595.49a42,42,0,1,0,37.19,0Z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_7944",
  "data-name": "Trac\\xE9 7944",
  d: "M500,639.87,231.82,530.08V712.7c154.93,130.68,381.49,130.68,536.41,0V530.08Z"
})));

function SvgTeachFull(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeachFull);
export default __webpack_public_path__ + "static/media/teach-full.05b6fd1f.svg";
export { ForwardRef as ReactComponent };